
import { defineComponent } from "vue";
import { VCarousel } from "vuetify/lib";

export default defineComponent({
  mixins: [VCarousel],
  props: {
    showArrows: {
      type: Boolean,
      default: false,
    },
  },
});
